import axios from 'axios';
import store from '../store';
export default {
  namespaced: true,

  state: {
    idmodal: '',
    descripcionmodal: '',
    banderamodal: null,
    caracteristicas: [],
    caracteristica: []

  },
  mutations: {
    LoadProductos(state, buscar) {
      //let aux = [];
      state.caracteristica = state.caracteristicas;

      let aux = state.caracteristica.filter((x) => x["nombrecaracteristica"].toUpperCase().includes(buscar.toUpperCase()),);
      if (buscar == "") {
        state.caracteristica = state.caracteristicas;
      } else {
        state.caracteristica = aux;

      }
    },



    async cargardatoscaracteristicas(state) {

      state.caracteristicas = []
      var token = store.state.numero;
      await axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/caracteristicas", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        })
        .then((response) => {
          state.caracteristicas = response.data.data;

        }).catch((e) => {
          console.log(e);
          location.reload();
        });
      state.caracteristica = state.caracteristicas
    },




    cambio(state, descripcion) {
      state.descripcionmodal = descripcion

    },
    agregartable(state) {

      //      this.descripcionmodal = descripcion
      var token = store.state.numero;
      var datos = {
        nombrecaracteristica: state.descripcionmodal
      };
      this.banderamodal = store.state.banderamodal



      var datosfalso = state.idmodal;

      if (this.banderamodal === true) {


        axios

          .post("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/caracteristicas", datos, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          })
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;


          })

          .catch((e) => {
            console.log(e);
            location.reload();
          });
      } else {


        axios

          .post(
            "https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/caracteristicas/UpdateReg/" +
            datosfalso,
            datos,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
              },
            }
          )
          .then((response) => {
            let tokenn = response.data.token;
            //this.respuesta = <z<
            this.token = tokenn;

          })

          .catch((e) => {
            console.log(e);
            location.reload();
          });
      }

    },


    datosmodal(state, api) {

      state.idmodal = api.idcaracteristica,
        state.descripcionmodal = api.nombrecaracteristica

    },



    eliminar(state, api) {
      var token = store.state.numero
      let eliminar = api;

      axios
        .get("https://juanabapl.juanabonita.com.co:446/Ecommerceh/api/caracteristicas/DeleteReg/" + eliminar,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          })


        .then((response) => {
          let tokenn = response.data.token;
          //this.respuesta = <z<
          state.eliminer = tokenn;

          //this.bandera = true;
        })
        .catch((e) => {
          console.log(e);
          location.reload();
        });


    },



  },
  actions: {

  },
  getters: {


  },






}